import React, { useState } from 'react';

export default function Profile() {
  const [errored, setErrored] = useState(false);

  return (
    <section className="profile">
      <div className="profile-pic-wrap">
        <img
          className="profile-pic"
          src={errored ? '/media/placeholder.png' : '/media/profile.jpg'}
          alt="Profile"
          onError={(e) => {
            if (!errored) {
              setErrored(true);
            } else {
              e.currentTarget.style.visibility = 'hidden';
            }
          }}
        />
      </div>
      <h1>Takion</h1>
      <p className="tagline">welcome to the void</p>
    </section>
  );
}
